export const common = {
    mixins: [],
    data() {
        return {};
    },
    methods: {
        /**
         * "params.operationFunction": 1, // 1-业务员详情 2-机构详情 3-团队详情  6-客户管理 14-个人险订单 15-个人险保单
         * "params.operationType": 1,// 1-证件号解密  2-手机号解密 3-银行卡号 4-邮箱 5-地址信息 
         */
        descrypt(params, bean, key,apiPermissionCode = '') {
            return this.$http({
                type: 'POST',
                url: '/buz/permissionLog/descrypt',
                data: params,
                apiPermissionCode
            }).then(res => {
                this.$set(bean, key, res.data.data);
            });
        },
        back(router) {
            const fullPath = this.$route.fullPath;
            if (router) {
                if(typeof router == "string") {
                    this.openPageTabTags(router);
                } else {
                    this.openPageTabTags(router.path, router.query);
                }

            } else {
                this.$router.go(-1);
            }
            window.setTimeout(() => {
                window.parent.postMessage(
                    {
                        removePageTag: fullPath,
                        appMessage: true
                    },
                    '*'
                );
            }, 100);
        },
    /*
      path:路由path
      obj:页面跳转query参数对象
    */
        openPageTabTags(path, query={}) {
            let pageTabTagPaths = JSON.parse(localStorage.getItem('pageTabTagPaths'));

            var rou = this.$router.resolve({
                path,
                query
            });

            let isAddUrl = pageTabTagPaths.find(item => this.delQueStr(item, 'time') == rou.href);

            if (isAddUrl) {
                this.$router.push({
                    path: isAddUrl
                });
            } else {
                query.time = Date.now();
                this.$router.push({
                    path,
                    query
                });
            }
        },
        // 设置页面标题 页面加载完调用
        setPageTitle(title){
            if(title.length > 20) {
                title = title.substr(0, 20) + "..."
            }
            this.$route.meta.title = title;
            this.$nextTick(() => {
            const arr = this.$route.matched
                .filter(item => item.meta.title)
                .map(item => {
                if (item.meta.title != "首页") {
                    return {
                    name: item.meta.title,
                    path: item.path
                    };
                }
                })
                .filter(item => item);
            window.parent.postMessage({
                nav: arr,
                setTagName: title,
                appMessage: true
            }, "*");
            });
        },
        //删除地址栏参数
        delQueStr: function (url, ref) {
            var str = '';
            if (url.indexOf('?') != -1) {
                str = url.substr(url.indexOf('?') + 1);
            } else {
                return url;
            }
            var arr = '';
            var returnurl = '';
            var setparam = '';
            if (str.indexOf('&') != -1) {
                arr = str.split('&');
                for (let i in arr) {
                    if (arr[i].split('=')[0] != ref) {
                        returnurl = returnurl + arr[i].split('=')[0] + '=' + arr[i].split('=')[1] + '&';
                    }
                }
                return url.substr(0, url.indexOf('?')) + '?' + returnurl.substr(0, returnurl.length - 1) + this.hasHash();
            } else {
                arr = str.split('=');
                if (arr[0] == ref) {
                    return url.substr(0, url.indexOf('?')) + this.hasHash();
                } else {
                    return url;
                }
            }
        },

        //判断是否存才hash
        hasHash: function () {
            if (window.location.hash && window.location.hash.length > 0) {
                if (this.isAL() && window.location.hash.split('?').length > 1) {
                    return '';
                }
                return window.location.hash;
            }
            return '';
        },
        // 清除表单验证信息
        clearValidate(formName = 'myForm') {
            this.$nextTick(()=>{
                this.$refs[formName] && this.$refs[formName].fields.forEach(item => {
                    item.validateState = '';
                    item.validateMessage = '';
                });
            })
        }
    }
};
export const pageTool = {
    data() {
        return {
            searchParams: {}, //查询参数
            searchParamsOrigin: {}, //查询参数
            pageNum: 1,
            pageSize: 10,
            tableData: [],
            listUrl: '',
            total: 0,
            listLoading: false,
            timer: {},
            subordinate: false,
            sourceShow: false,
            searchMore: false
        };
    },
    activated() {
        // 触发表格组件重新渲染
        document.getElementById('layoutMain') && (document.getElementById('layoutMain').style = 'padding-right:32px');
        window.setTimeout(() => {
            document.getElementById('layoutMain') && (document.getElementById('layoutMain').style = '');
        }, 1);
    },
    methods: {
        initListAjax(url, type) {
            if (type == 'subordinate') {
                this.subordinate = true;
            }
            if (type == 'source') {
                this.sourceShow = true;
            }
            this.initListParams(url);
            this.getList();
        },
        initListParams(url){
            this.listUrl = url;
            this.pageNum = 1;
            this.pageSize = 10;
            this.searchParamsOrigin = JSON.parse(JSON.stringify(this.searchParams));
        },
        // 重置查询
        resetSearch() {
            this.searchParams = JSON.parse(JSON.stringify(this.searchParamsOrigin));
            this.searchAjax();
        },
        // 搜索
        searchAjax(url) {
            if (url) {
                this.listUrl = url;
            }
            this.listLoading = true;
            this.pageNum = 1;
            clearTimeout(this.timer);
            this.timer = setTimeout(_ => {
                this.getList();
            }, 500);
        },
        searchAjax2() {
            this.listLoading = true;
            this.pageNum = 1;
            this.tableData = [];
            this.getList();
        },
        setRequstType() {},
        // 设置自定义参数
        setListParams(params) {},
        //自定义相关参数
        setReqParams(params){},
        //请求回调
        listCallback() {},
        pageSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.pageNum = 1;
            this.getList();
        },
        // ajax请求
        getList(pageNum) {
            const params = Object.assign({}, this.searchParams);
            if (pageNum) {
                this.pageNum = pageNum;
            }
            params.pageNo = this.pageNum;
            params.pageSize = this.pageSize;
            if (this.subordinate) {
                params.isLowerOrg = 1;
                params.source = '2';
            }
            if (this.sourceShow) {
                params.source = '1';
            }
            this.setListParams(params);
            this.listLoading = true;
            if (!this.listUrl) {
                return;
            }
            let reqParams = {
                type: this.setRequstType() || 'POST',
                url: this.listUrl,
                data: params
            }
            this.setReqParams(reqParams);
            this.$http(reqParams)
                .then(resData => {
                    // 翻页无数据回退上一页 只有一页不处理
                    if((!resData.data||resData.data.length==0)&&this.pageNum!=1) {
                        this.pageNum--;
                        this.getList();
                        return;
                    }
                    this.listCallback(resData);
                    this.total = resData.total;
                    this.tableData = resData.data;
                })
                .finally(e => {
                    this.listLoading = false;
                });
        }
    }
};
// 验证码倒计时
const CODE_SIZE = 60;
export const codeTools = {
    data() {
        return {
            CODE_SIZE,
            codeIndex: CODE_SIZE,
            timer: {}
        };
    },
    destroyed() {
        window.clearInterval(this.timer);
    },
    methods: {
        clearCodeTimer() {
            window.clearInterval(this.timer);
            this.codeIndex = CODE_SIZE;
        },
        timerStart() {
            if (this.codeIndex != CODE_SIZE) {
                return;
            }
            window.clearInterval(this.timer);
            this.codeIndex--;
            this.timer = window.setInterval(() => {
                this.codeIndex--;
                if (this.codeIndex <= 0) {
                    window.clearInterval(this.timer);
                    this.codeIndex = CODE_SIZE;
                    return;
                }
            }, 1000);
        },
        getCodeAjax(mobile) {
            if (!this.$regulars.isPhone(mobile)) {
                this.$notice.msg('请输入正确的手机号');
                return;
            }
            this.timerStart();
            this.$http({
                type: 'GET',
                url: '/api/user/sendCode',
                data: {
                    mobile
                }
            })
                .then(res => {})
                .catch(e => {
                    window.clearInterval(this.timer);
                    this.codeIndex = CODE_SIZE;
                });
        }
    }
};
